import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { API } from "../../constants/Api";
import { useNavigate } from "react-router-dom";

function MakeOfferFormThree({ props }) {
  const houseAddress = localStorage.getItem("houseAddress");
  const houseZipCode = localStorage.getItem("houseZipCode");
  const houseImages = localStorage.getItem("houseImages");

  const [employeementStatus, setEmployeementStatus] = useState("W2");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  function formValidations() {
    if (employeementStatus.length < 1) {
      toast.error("Employement Status is required");
      return false;
    }
    if (props.downPayment.length < 1) {
      toast.error("Down Payment is required");
      return false;
    }
    if (props.yesOrNo === "yes" && props.tourDateTime.length < 1) {
      toast.error("Date Time is required");
      return false;
    }

    return true;
  }
  const removeCommasFromNumber = (numString) => {
    return numString.replace(/,/g, "");
  };
  const handleContinue = async () => {
    const isValid = await formValidations();

    if (isValid) {
      const formData = new FormData();
      if (props.bankContractPdf) {
        formData.append("bankContractPdf", props.bankContractPdf);
      }

      formData.append("employeementStatus", employeementStatus);
      // formData.append("downPayment", props.downPayment);
      formData.append("downPayment", removeCommasFromNumber(props.downPayment));

      if (props.yesOrNo === "yes") {
        formData.append("tourDateTime", props.tourDateTime);
      }
      formData.append("yesOrNo", props.yesOrNo);
      formData.append("houseAddress", houseAddress);
      formData.append("houseZipCode", houseZipCode);
      formData.append("houseImages", houseImages);
      formData.append("contractExpireDate", props.tourDateTimeExpiry);

      setLoading(true);
      const loadtingToast = toast.loading("Submitting Details...");
      try {
        const response = await fetch(
          `${API}/MakeAnoffer/create-user-makeanoffer`,
          {
            method: "POST",
            body: formData,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await response.json();
        if (response.ok) {
          setLoading(false);
          toast.dismiss(loadtingToast);
          toast.success("We Have Received Your Tour Request");
          navigate("/user-auth/profile");
        } else {
          setLoading(false);
          toast.dismiss(loadtingToast);
          toast.error(json.message);
        }
      } catch (error) {
        setLoading(false);
        toast.dismiss(loadtingToast);
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const formatNumberWithCommas = (e) => {
    let value = e.target.value;

    // Allow only numbers, commas, and a single decimal point
    value = value.replace(/[^0-9,.]/g, "");

    // Ensure only one decimal point exists
    const decimalCount = (value.match(/\./g) || []).length;
    if (decimalCount > 1) {
      value = value.substring(0, value.lastIndexOf("."));
    }

    // Split into whole and decimal parts
    let [whole, decimal] = value.split(".");

    // Remove existing commas from whole number part
    whole = whole.replace(/\D/g, "");

    // Check if exceeds 999 million
    if (parseInt(whole, 10) > 999999999) {
      // toast.error("Down payment cannot exceed 999 million");
      return;
    }

    // Add commas to whole number part
    whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Combine whole and decimal parts
    value = decimal !== undefined ? `${whole}.${decimal}` : whole;

    props.setDownPayment(value);
  };
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <form className="agent-register-form">
        <p className="before-begin-span">Your employement status?</p>
        <div className="d-flex gap-5">
          <div className="mb-3 form-check agent-register-verify-check-group px-0">
            <img
              role="button"
              onClick={() => setEmployeementStatus("W2")}
              src={`${employeementStatus === "W2" ? "/img/checked.svg" : "/img/uncheck.svg"}`}
              className="img-fluid"
              alt=""
            />

            <label className="form-check-label ms-3" htmlFor="exampleCheck1">
              W2
            </label>
          </div>
          <div className="mb-3 form-check agent-register-verify-check-group px-0">
            <img
              role="button"
              onClick={() => setEmployeementStatus("Self Employed")}
              src={`${employeementStatus === "Self Employed" ? "/img/checked.svg" : "/img/uncheck.svg"}`}
              className="img-fluid"
              alt=""
            />

            <label className="form-check-label ms-3" htmlFor="exampleCheck1">
              Self Employed
            </label>
          </div>
        </div>

        {isMobile ? (
          <input
            type="text"
            className="form-control agent-register-input-field"
            id="exampleInputEmail1"
            placeholder="Full Name"
            aria-describedby="emailHelp"
            onChange={formatNumberWithCommas}
            value={`$ ${props.downPayment}`}
            maxLength={15}
          />
        ) : (
          <div className="agent-register-phone-number-group">
            <button disabled className="agent-register-phone-code-2">
              $
            </button>
            <input
              type="text"
              className="form-control agent-register-phone-field-2"
              id="exampleInputEmail1"
              placeholder="Down Payment"
              aria-describedby="emailHelp"
              onChange={formatNumberWithCommas}
              value={props.downPayment}
              maxLength={15}
            />
          </div>
        )}

        {props.yesOrNo === "no" ? (
          <></>
        ) : (
          <>
            <hr
              className="text-white agent-register-devider-1"
              style={{ opacity: "0.1" }}
            />
            <p className="schedule-tour-span">
              What Time suits you best for the tour?
            </p>
            <input
              type="datetime-local"
              className="form-control agent-register-input-field"
              id="exampleInputEmail1"
              placeholder="Your Website"
              aria-describedby="emailHelp"
              onChange={(e) => props.setTourDateTime(e.target.value)}
            />
          </>
        )}

        <span onClick={handleContinue} className="btn agent-register-button">
          Contact Agent
        </span>
      </form>
    </>
  );
}

export default MakeOfferFormThree;
